import Roles from "../../../../pages/roles/role-management/Roles";
import Users from "../../../../pages/users/Users";
import Settings from "../../../../pages/settings/Settings";
import Visitors from "../../../../pages/visitors/Visitors";
import Login from "../../../auth/Login";
import EvaluationDetails from "../../../creative-work-requests/evaluation-details/EvaluationDetails";
import ReaderEvaluation from "../../../creative-work-requests/evaluation/ReaderEvaluation";
import Statistics from "../../../dashboard/statistics/statistics-page/Statistics";
import EvaluationType from "../../../evaluation-types/EvaluationType";
import ProjectTypes from "../../../project-types/ProjectTypes";
import EvaluationDetailsByReader from "../../../creative-work-requests/evaluation-details/EvaluationDetailsByReader";
import NotificationsPage from "../../../notification/Notifications";
import Profile from "../../../../pages/profile/Profile";
import ShowWarehouses from "../../../../pages/warehouses/warehouses-crud/ShowWarehouses";
import AddProduct from "../../../../pages/warehouses/products/add-product/AddProduct";
import ShowProducts from "../../../../pages/warehouses/products/show-products/ShowProducts";
import Config from "../../../../pages/warehouses/configration/Config";
import Index from "../../../../pages/warehouses/warehouses-crud/details-of-warehouse/Index";
import IndexDetailsProduct from "../../../../pages/warehouses/products/details-product/IndexDetailsProduct";
import Suppliers from "../../../../pages/warehouses/suppliers/Suppliers";
import ScriptsArchive from "../../../../pages/scripts-archive/ScriptsArchive";
import AddScriptsArchive from "../../../../pages/scripts-archive/AddScriptsArchive";
import DetailsOfScriptArchive from "../../../../pages/scripts-archive/DetailsOfScriptArchive";
import Sequence from "../../../../pages/warehouses/requests/Sequence";
import AddRequest from "../../../../pages/warehouses/requests/add-request/AddRequest";
import EditRequest from "../../../../pages/warehouses/requests/edit-request/EditRequest";
import DetailsRequest from "../../../../pages/warehouses/requests/details-request/DetailsRequest";
import AllAccounts from "../../../../pages/accounting/accounts/AllAccounts";
import AllTransactions from "../../../../pages/accounting/transactions/AllTransactions";
import AllStatements from "../../../../pages/accounting/statements/AllStatements";
import AllExpenses from "../../../../pages/accounting/expenses/AllExpenses";
import StatementsExpenses from "../../../../pages/accounting/statements/StatementsExpenses";
import CreativeWorkRequests from '../../../../components/creative-work-requests/creative-work-requests-page/CreativeWorkRequests';
import ReportAccounts from "../../../../pages/accounting/accounts/report-account/ReportAccounts";
import AllSettingsAccounting from "../../../../pages/accounting/settings-accounting/AllSettingsAccounting";
import TableCard from "../../../../pages/vcard/table-card";
import AddVCard from "../../../../pages/vcard/add-vcard/AddVCard";
import ReportAccounting from "../../../../pages/accounting/report";

const useRout = (token) => {

    const routes = [
        { path: "/", element: token == null ? <Login /> : <Statistics /> },
        { path: "/visitors", element: token == null ? <></> : <Visitors /> },
        { path: "/project-request", element: token == null ? <></> : <CreativeWorkRequests /> },
        { path: "/project-request/:creativeWorkId/details", element: token == null ? <></> : <EvaluationDetails /> },
        { path: "/project-request/:id", element: token == null ? <></> : <ReaderEvaluation /> },
        { path: "/project-types", element: token == null ? <></> : <ProjectTypes /> },
        { path: "/users", element: token == null ? <></> : <Users /> },
        { path: "roles", element: token == null ? <></> : <Roles /> },
        { path: "/evaluation-types", element: token == null ? <></> : <EvaluationType /> },
        { path: "/settings", element: token == null ? <></> : <Settings /> },
        { path: "/project-request/:creativeWorkId/details/:readerId/details", element: token == null ? <></> : <EvaluationDetailsByReader /> },
        { path: "/notifications", element: token == null ? <></> : <NotificationsPage /> },
        { path: "/profile", element: token == null ? <></> : <Profile /> },
        { path: "/warehouses", element: token == null ? <></> : <ShowWarehouses /> },
        { path: "/add-material", element: token == null ? <></> : <AddProduct /> },
        { path: "/materials", element: token == null ? <></> : <ShowProducts /> },
        { path: "/warehouse/:id/:name/materials", element: token == null ? <></> : <ShowProducts /> },
        { path: "/warehouses/config", element: token == null ? <></> : <Config /> },
        { path: "/warehouses/:id", element: token == null ? <></> : <Index /> },
        { path: "/material/:id", element: token == null ? <></> : <IndexDetailsProduct /> },
        { path: "/supplier", element: token == null ? <></> : <Suppliers /> },
        { path: "/scripts-archive", element: token == null ? <></> : <ScriptsArchive /> },
        { path: "/add-scripts-archive", element: token == null ? <></> : <AddScriptsArchive /> },
        { path: "/scripts-archive/:id", element: token == null ? <></> : <DetailsOfScriptArchive /> },
        { path: "/requests", element: token == null ? <></> : <Sequence /> },
        { path: "/add-request", element: token == null ? <></> : <AddRequest /> },
        { path: "/requests/edit/:id", element: token == null ? <></> : <EditRequest /> },
        { path: "/requests/:id", element: token == null ? <></> : <DetailsRequest /> },
        { path: "/accounts", element: token == null ? <></> : <AllAccounts /> },
        { path: "/accounts/:id/report", element: token == null ? <></> : <ReportAccounts /> },
        { path: "/transactions", element: token == null ? <></> : <AllTransactions /> },
        { path: "/statements", element: token == null ? <></> : <AllStatements /> },
        { path: "/expenses", element: token == null ? <></> : <AllExpenses /> },
        { path: "/vcards", element: token == null ? <></> : <TableCard /> },
        { path: "/add-vcards", element: token == null ? <></> : <AddVCard /> },
        { path: "/settings-accounting", element: token == null ? <></> : <AllSettingsAccounting /> },
        { path: "/statements-expenses/:id", element: token == null ? <></> : <StatementsExpenses /> },
        {path: "/report-accounting", element: token == null ? <></> : <ReportAccounting /> },
    ];
    return routes;
}


export default useRout;